import React from 'react';
import { Grid, TextField, FormControlLabel, Checkbox, Autocomplete } from '@mui/material';
import { bloodComponents, bloodGroups } from '../constants/options';

const BloodProductOrders = ({ formData, setFormData, handleChange, handleBloodOrderChange, validationErrors }) => {
  return (
    <Grid container spacing={2}>
      {bloodComponents.map((comp) => (
        <Grid item xs={12} sm={6} key={comp}>
          <TextField
            type="number"
            label={`${comp} Units`}
            value={formData.bloodOrders[comp] || ''}
            onChange={(e) => handleBloodOrderChange(comp, e.target.value)}
            fullWidth
            inputProps={{ min: 0, max: 20 }}
            error={!!validationErrors[`bloodOrder_${comp}`]}
            helperText={validationErrors[`bloodOrder_${comp}`] || "Max 20 units"}
          />
        </Grid>
      ))}
      <Grid item xs={12} sm={6}>
        <FormControlLabel
          control={<Checkbox name="sopNeeded" checked={formData.sopNeeded} onChange={handleChange} />}
          label="SOP Needed"
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <Autocomplete
          options={bloodGroups}
          value={formData.bloodGroup || ''}
          onChange={(e, newValue) => setFormData(prev => ({ ...prev, bloodGroup: newValue || '' }))}
          renderInput={(params) => (
            <TextField
              {...params}
              name="bloodGroup"
              label="Blood Group"
              helperText="Select patient's blood group"
            />
          )}
        />
      </Grid>
      <Grid item xs={12}>
        <FormControlLabel
          control={<Checkbox name="prdcAttached" checked={formData.prdcAttached} onChange={handleChange} />}
          label="PRDC Attached"
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          name="transfusionNotes"
          label="Transfusion Notes"
          value={formData.transfusionNotes || ''}
          onChange={handleChange}
          fullWidth
          multiline
          rows={2}
        />
      </Grid>
    </Grid>
  );
};

export default BloodProductOrders;
